var _rect, _path, _rect2, _rect3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInStreamIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 108,
    viewBox: "0 0 140 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 80,
    height: 56,
    fill: "#DAD8DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1844 43.7112L37.2344 38.5799C37.0125 38.3893 36.6875 38.5612 36.6875 38.869V49.1315C36.6875 49.4393 37.0125 49.6112 37.2344 49.4205L43.1844 44.2893C43.3547 44.1424 43.3547 43.858 43.1844 43.7112Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 16,
    width: 52,
    height: 76,
    fill: "#EFEEEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 76,
    width: 80,
    height: 16,
    fill: "#EFEEEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 0L84 108",
    stroke: "#6E28FC",
    strokeDasharray: "3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInStreamIcon);
export default __webpack_public_path__ + "static/media/in-stream-icon.5c923aa6bd73509818da7e6b427b6926.svg";
export { ForwardRef as ReactComponent };